export enum RecurrenceTypeEnum {
  INTERVAL_DAYS = 'interval_days',
  WEEK_DAYS = 'week_days',
}

export interface VehicleRecurrence {
  id: number;
  chassis: string;
  recurrence_type: RecurrenceTypeEnum;
  interval_days?: number | null;
  week_days?: number[] | null;
  next_due_date?: string | null;
  last_checklist_at?: string | null;
  active: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface VehicleRecurrenceUpsertParams {
  chassis: string;
  recurrence_type: RecurrenceTypeEnum;
  interval_days?: number | null;
  week_days?: number[] | null;
  active?: boolean;
}

export interface VehicleStatusItem {
  chassis: string;
  productName?: string | null;
  lastChecklistUserName?: string | null;
  lastChecklistAt: string | null;
  nextDueDate: string | null;
  recurrenceType: RecurrenceTypeEnum | null;
  intervalDays?: number | null;
  weekDays?: number[] | null;
  daysOverdue: number;
  hasRecurrence: boolean;
}

export interface VehicleStatusResponse {
  em_dia: VehicleStatusItem[];
  atrasado: VehicleStatusItem[];
  sem_recorrencia: VehicleStatusItem[];
}
